module.exports = "<div ng-if=vm.user.isAuthenticated class=panel-body> <p>Welcome {{vm.user.profile.given_name}}. Please select your store from the list below to begin.</p> <div class=form-control storeselector=vm.store></div> <button type=button class=\"btn btn-default btn-block\" ng-click=vm.proceed() ng-disabled=!vm.store.storeId>Continue</button> </div> <div ng-if=!vm.user.isAuthenticated class=\"panel-body loading-message\"> <loadingindicator></loadingindicator> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/guest/storeselector/template.html
// module id = 198
// module chunks = 0